import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {
  getUniversitiesLoading,
  getUniversitiesError,
  getUniversitiesLoaded,
  getUniversitiesFilteredBy,
  sortUniversitiesByName,
} from '../selectors';
import {fetchUniversities} from '../actionCreators';

const filterUniversitiesByName = name => state => getUniversitiesFilteredBy(state, {name}, sortUniversitiesByName);

const useUniversities = (nameFilter, params, forceReload = false) => {
  const universities = useSelector(filterUniversitiesByName(nameFilter));
  const loaded = useSelector(getUniversitiesLoaded);
  const loading = useSelector(getUniversitiesLoading);
  const error = useSelector(getUniversitiesError);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!loaded || forceReload) dispatch(fetchUniversities(params));
    return () => null;
    // We don't want `loaded` in the dependancies for this function.
    // It can cause an infinite loop, since loaded is a timestamp.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, params, forceReload]);

  return [universities, loading, error];
};

export default useUniversities;
